// extracted by mini-css-extract-plugin
export default {"mainContainer":"MinistryWarehouseRequestDetails_mainContainer__Llxox"};